import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import {RouterProps} from "../../../../RouterProps";
import Post from "./Post";
import Edit from "./Edit";

export default function ReasonRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
            <Route path={'/:contentCommentReportReasonId'} element={<Detail {...props} />} />
            <Route path={'/:contentCommentReportReasonId/edit'} element={<Edit {...props} />} />
        </Routes>
    </>
}